import { Pipe, PipeTransform } from '@angular/core';
import { AssetClass } from '@fullyops/data/asset-types/asset-type';
import { AssetCriticality } from '@fullyops/data/assets/asset';
import { TranslatePipe } from '@fullyops/shared/pipes/translate.pipe';
import { en } from './en';
import { es } from './es';
import { pt } from './pt';

export type AssetFormTranslationKey =
  | 'name'
  | 'assetType'
  | 'active'
  | 'assetClass'
  | AssetClass
  | 'generic'
  | 'createdAt'
  | 'company'
  | 'companies'
  | 'category'
  | 'location'
  | 'locations'
  | 'parent'
  | 'description'
  | 'externalId'
  | 'criticality'
  | AssetCriticality
  | 'installedAt'
  | 'hasWarranty'
  | 'warranty'
  | 'warrantyExpiresAt'
  | 'noWarranty'
  | 'inWarranty'
  | 'outOfWarranty'
  | 'brand'
  | 'model'
  | 'serialNumber'
  | 'type'
  | 'manufacturedAt'
  | 'noneCriticality'
  | 'noneGeneric'
  | 'any'
  | 'create'
  | 'assetsPerPage'
  | 'inactive'
  | 'change'
  | 'genericType'
  | 'noCustomFields'
  | 'oneCustomField'
  | 'customFields'
  | 'chooseAssetType'
  | 'general'
  | 'ownershipAndLocation'
  | 'installationAndWarranty'
  | 'equipmentDetails'
  | 'customFieldsSection'
  | 'attachments'
  | 'generalDescription'
  | 'ownershipAndLocationDescription'
  | 'installationAndWarrantyDescription'
  | 'equipmentDetailsDescription'
  | 'customFieldsSectionDescription'
  | 'attachmentsDescription'
  | 'invalidInteger'
  | 'invalidDecimal'
  | 'valueOutOfRange'
  | 'status'
  | 'openAsset'
  | 'close'
  | 'save'
  | 'add'
  | 'noCompanyAssets';

@Pipe({ name: 'i18nextCap' })
export class AssetFormTranslatePipe
  extends TranslatePipe<AssetFormTranslationKey>
  implements PipeTransform
{
  readonly translations = { en, es, pt };
}
